var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "48px",
    viewBox: "0 0 72 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/Tender_JCB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tender_JCB",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 0,
    y: 0,
    width: 72,
    height: 48,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9988,25.4932 L46.0068,25.4932 C46.1308,25.4932 46.3708,25.4732 46.4848,25.4492 C47.2528,25.2832 47.8928,24.5992 47.8928,23.6692 C47.8928,22.7392 47.2528,22.0532 46.4848,21.8872 C46.3708,21.8632 46.1308,21.8412 46.0068,21.8412 L41.9988,21.8412 L41.9988,25.4932 Z",
    id: "Fill-4",
    fill: "#57B27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5378,0.2304 C41.7158,0.2304 38.6138,3.3304 38.6138,7.1524 L38.6138,14.3444 L48.4118,14.3444 C48.6378,14.3444 48.9158,14.3584 49.0878,14.3684 C51.3058,14.4804 52.9398,15.6184 52.9398,17.5964 C52.9398,19.1484 51.8238,20.4764 49.7898,20.7744 L49.7898,20.8544 C52.0358,21.0104 53.7558,22.2444 53.7558,24.1944 C53.7558,26.3004 51.8678,27.6564 49.3518,27.6564 L38.6138,27.6564 L38.6138,41.7684 L48.7678,41.7684 C52.5918,41.7684 55.6918,38.6684 55.6918,34.8464 L55.6918,0.2304 L45.5378,0.2304 Z",
    id: "Fill-6",
    fill: "#57B27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4188,18.0958 C47.4188,17.1818 46.7788,16.5678 46.0268,16.4418 C45.9568,16.4298 45.7648,16.4098 45.6308,16.4098 L41.9988,16.4098 L41.9988,19.7818 L45.6308,19.7818 C45.7648,19.7818 45.9568,19.7618 46.0268,19.7498 C46.7788,19.6238 47.4188,19.0098 47.4188,18.0958",
    id: "Fill-8",
    fill: "#57B27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2312,0.2304 C3.4072,0.2304 0.3072,3.3304 0.3072,7.1524 L0.3072,24.2504 C2.2492,25.1904 4.2572,25.8044 6.2972,25.8044 C8.6892,25.8044 10.0072,24.3424 10.0072,22.3764 L10.0072,14.3444 L15.9592,14.3444 L15.9592,22.3764 C15.9592,25.5184 14.0312,28.0384 7.4152,28.0384 C3.4332,28.0384 0.3072,27.1784 0.3072,27.1784 L0.3072,41.7684 L10.4612,41.7684 C14.2852,41.7684 17.3852,38.6684 17.3852,34.8464 L17.3852,0.2304 L7.2312,0.2304 Z",
    id: "Fill-10",
    fill: "#48A0DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3856,0.2304 C22.5616,0.2304 19.4616,3.3304 19.4616,7.1524 L19.4616,16.2164 C21.2156,14.7124 24.2496,13.7724 29.1776,13.9944 C31.8156,14.1104 34.6116,14.8184 34.6116,14.8184 L34.6116,17.7504 C33.2136,17.0404 31.5336,16.3844 29.3696,16.2204 C25.6296,15.9384 23.3796,17.7644 23.3796,21.0004 C23.3796,24.2344 25.6296,26.0624 29.3696,25.7784 C31.5336,25.6164 33.2356,24.9404 34.6116,24.2504 L34.6116,27.1804 C34.6116,27.1804 31.8156,27.8864 29.1776,28.0064 C24.2496,28.2284 21.2156,27.2884 19.4616,25.7824 L19.4616,41.7684 L29.6156,41.7684 C33.4376,41.7684 36.5376,38.6684 36.5376,34.8464 L36.5376,0.2304 L26.3856,0.2304 Z",
    id: "Fill-12",
    fill: "#CE5052"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "assets/media/jcb.1c5558c3bb642faf10beca0458df8941.svg";
export { ForwardRef as ReactComponent };